import { gql } from '@apollo/client';

export const DELETE_INDICATOR_PERIOD_DATE = gql`
  mutation deleteIndicatorPeriodDate($id: ID!) {
    deleteIndicatorPeriodDate(id: $id) {
      id
    }
  }
`;
